<template>
    <div>
        <span class="text-primary cursor-pointer hover:font-semibold hover:underline" @click="detailsRecord">{{params.data.loyaltyCustomer.fullName}}</span>

        <vs-popup class="holamundo customer-info" title="Khách hàng" :active.sync="popupInfo" id="customer_info_popup"
                  v-if="popupInfo">
            <vs-tabs v-model="activeTab">
                <vs-tab label="Thông tin khách hàng">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <CustomerInformation :loyaltyCustomerId="dataRow.id"></CustomerInformation>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử cuộc gọi">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <CallHistory :loyaltyCustomerId="dataRow.id"></CallHistory>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử tư vấn">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <ConsultingStep :loyaltyCustomerId="dataRow.id"></ConsultingStep>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử thanh toán">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <FeeCollectionStep :loyaltyCustomerId="dataRow.id"></FeeCollectionStep>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử điều trị">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <SubclinicalStep :loyaltyCustomerId="dataRow.id"></SubclinicalStep>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử nhắn tin">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <HistorySMS :loyaltyCustomerId="dataRow.id"></HistorySMS>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử ra vào">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <InOutHistory :loyaltyCustomerId="dataRow.id"></InOutHistory>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử đặt lịch">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <BookingHistory :loyaltyCustomerId="dataRow.id"></BookingHistory>
                    </VuePerfectScrollbar>
                </vs-tab>
            </vs-tabs>
            <div class="vx-row mt-4">
                <div class="vx-col w-full">
                    <div class="flex flex-wrap justify-end gap-4">

                        <vs-button icon-pack="feather" icon="icon-phone-call" @click="callToCustomer(null)"
                                   v-if="userInfo.userRole == 'user' && isPermissionCall">Gọi điện
                        </vs-button>
                        <vs-button icon-pack="feather" icon="icon-mail" @click="sendSMS">Gửi SMS</vs-button>
                        <vs-button icon-pack="feather" icon="icon-x" color="danger" type="border"
                                   @click="popupInfo = false">Đóng
                        </vs-button>
                    </div>
                </div>
            </div>

            <vs-popup class="holamundo" title="Gửi SMS" :active.sync="popupSendSMSCustomer" id="send_sms_customer">
                <div class="vx-row">
                    <div class="vx-col w-full mt-4">
                        <label class="vs-input--label">Tổng đài</label>
                        <v-select class="w-full" v-model="smsSendInfo.smsBrandNameId"
                                  :options="brandNameOptions" :reduce="item => item.value">
                        </v-select>
                    </div>
                    <div class="vx-col w-full mt-4">
                        <label class="vs-input--label">Nội dung</label>
                        <vs-textarea class="w-full" v-model="smsSendInfo.messageTitle"/>
                    </div>
                    <div class="vx-col w-full">
                        <div class="flex justify-end gap-4">
                            <vs-button icon-pack="feather" icon="icon-send" @click="send">Gửi</vs-button>
                            <vs-button icon-pack="feather" icon="icon-x" type="border" color="danger"
                                       @click="cancelSend">Hủy
                            </vs-button>
                        </div>
                    </div>
                </div>
            </vs-popup>
        </vs-popup>
    </div>
</template>

<script>
import moment from "moment";
import {en, vi} from "vuejs-datepicker/dist/locale";
import vSelect from 'vue-select';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Vietnamese} from 'flatpickr/dist/l10n/vn';
import {isAPI} from "../../../../../store/permission";
import {constAPI} from "../../../../../store/constant";
import Datepicker from 'vuejs-datepicker';

import ConsultingStep from "../../customer/cell-renderer/medical-step/ConsultingStep";
import FeeCollectionStep from "../../customer/cell-renderer/medical-step/FeeCollectionStep";
import SubclinicalStep from "../../customer/cell-renderer/medical-step/SubclinicalStep";
import HistorySMS from "../../customer/cell-renderer/history-sms/HistorySMS";
import InOutHistory from "../../customer/cell-renderer/medical-step/InOutHistory";
import BookingHistory from "../../customer/cell-renderer/medical-step/BookingHistory";
import CustomerInformation from "../../customer/CustomerInformation";
import CallHistory from "../../customer/cell-renderer/medical-step/CallHistory";

export default {
    name: "CellRendererDetailsCustomer",
    components: {
        vSelect,
        VuePerfectScrollbar,
        flatPickr,
        Datepicker,
        ConsultingStep,
        FeeCollectionStep,
        SubclinicalStep,
        HistorySMS,
        InOutHistory,
        BookingHistory,
        CustomerInformation,
        CallHistory,
    },
    data() {
        return {
            popupInfo: false,
            organizationBranchOptions: [],
            customerInfo: {
                id: null,
                code: null,
                fullName: null,
                phoneNumber: null,
                city: null,
                district: null,
                fullAddress: null,
                houseNumber: null,
                birthday: null,
                gender: null,
                email: null,
                ethnic: null,
                job: null,
                country: "Việt Nam",
                firstName: null,
                lastName: null,
                organizationBranchId: null,
                passport: null,
                street: null,
                weight: null,
                sourceType: null,
            },
            highlighted: {
                dates: [
                    new Date()
                ]
            },
            disabledFn: {
                customPredictor(date) {
                    if (moment(date).isAfter(moment(), 'days')) {
                        return true;
                    }
                }
            },
            en: en,
            vi: vi,
            genderOptions: [
                {value: null, label: 'Tất cả'},
                {value: 0, label: this.$t('genderOption.unknown')},
                {value: 1, label: this.$t('genderOption.male')},
                {value: 2, label: this.$t('genderOption.female')}
            ],
            customerId: null,
            configDatePickerInfo: {
                dateFormat: 'Z',
                // defaultDate: new Date(),
                locale: Vietnamese,
                maxDate: new Date(),
                altFormat: 'd/m/Y',
                altInput: true,
                wrap: true,
                allowInput: true,
            },
            typeCustomer: [
                {value: 1, label: 'Khách hàng chính thức'},
                {value: 2, label: 'Khách hàng tiềm năng'},
            ],
            sourceTypeOptions: [
                {value: 2, label: 'Nguồn phòng ban'},
                {value: 3, label: 'Nguồn cá nhân'},
            ],
            departmentData: [],
            showSelectedSourceType: false,
            employeeInfo: null,
            autoCreateMedicalRecordCheck: false,
            activeTab: 0,
            brandNameOptions: [],
            popupSendSMSCustomer: false,
            configTimePicker: {
                minDate: new Date(),
                enableTime: true,
                time_24hr: true,
                locale: Vietnamese,
            },
            smsSendInfo: {
                smsBrandNameId: null,
                messageType: null,
                sendTimeStr: null,
                messageTitle: null,
            },
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .30,
                suppressScrollX: true,
            },
            dataRow: null,
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
        }
    },

    computed: {
        isPermissionCall() {
            return isAPI(this, constAPI.beauty_call)
        },
    },

    methods: {
        async detailsRecord() {
            this.dataRow = this.params.data.loyaltyCustomer;
            this.activeTab = 0;
            this.popupInfo = true;
        },

        callToCustomer() {
            let dataRow = this.dataRow;
            dataRow['isCreateBooking'] = true;
            this.$eventBus.$emit("beauty-call", dataRow);
        },

        //Send SMS
        async sendSMS() {
            await this.getBrandName();
            this.popupSendSMSCustomer = true;
        },
        getBrandName() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/sms-brand-name/get-all').then(res => {
                    if (res.data && res.data.length > 0) {
                        this.brandNameOptions = res.data.map(el => {
                            return {
                                value: el.id,
                                label: el.brandName,
                            }
                        })
                    }
                    this.$vs.loading.close();
                    resolve(res);
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Error',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        cancelSend() {
            this.smsSendInfo = {
                smsBrandNameId: null,
                messageType: null,
                sendTimeStr: null,
                messageTitle: null,
            }
            this.popupSendSMSCustomer = false;
        },
        send() {
            let payload = {
                messageType: 1,
                loyaltyCustomerIds: [this.dataRow.id],
                message: this.smsSendInfo.messageTitle,
                smsBrandNameId: this.smsSendInfo.smsBrandNameId,
                sendTimeStr: moment(new Date().toISOString()).format('yyyyMMDDHHmmss'),
                sendStatus: 1,
            }
            this.$vs.loading();
            this.$crm.post('/sms-message-config/create', payload).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Gửi tin nhắn thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.cancelSend();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        // End Send
    }
}
</script>

<style lang="scss">
#customer_info_popup {

.vs-popup {
    width: 80%;
}

//@media (min-width: 1280px) {
//    .vs-popup {
    //        width: 1200px !important;
    //    }
//}
//
//@media (max-width: 1279px) and (min-width: 1024px) {
//    .vs-popup {
    //        width: 1000px !important;
    //    }
//}
//
//@media (max-width: 1023px) and (min-width: 768px) {
//    .vs-popup {
    //        width: 700px !important;
    //    }
//}
//
//@media (max-width: 767px) and (min-width: 640px) {
//    .vs-popup {
    //        width: 600px !important;
    //    }
//}

.vs-textarea {
    height: 200px;
}

.vs-popup--content {
    min-height: 500px;

.con-slot-tabs {
    min-height: 500px;
}
}

.scroll-area--nofications-dropdown, .scroll-area--cart-items-dropdowm {
    max-height: 40rem;
}

.flip-card {
    background-color: transparent;
    width: 300px;
    height: 150px;
    perspective: 1000px;
    font-family: sans-serif;
}

.title {
    font-size: 1.5em;
    font-weight: 900;
    text-align: center;
    margin: 0;
}

.flip-card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 0.8s;
    transform-style: preserve-3d;
}

.flip-card:hover .flip-card-inner {
    transform: rotateY(180deg);
}

.flip-card-front, .flip-card-back {
    box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.2);
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    border-radius: 1rem;
}

.flip-card-back {
    transform: rotateY(180deg);
}
}

#popup-history-call {
.vs-popup--header {
    display: none;
}
}

#popup-history-call-record {
.vs-popup--header {
    display: none;
}
}

.nostar_desc {
    display: none !important;
}

#call_history {
    min-height: 400px;
}
</style>
